import { mutationTypes } from './types'
import initialState from './initial-state'

export default {
  [mutationTypes.RESET_STATE]: (state, dirty) => {
    const initState = initialState()
    Object.keys(initState).forEach(key => {
      state[key] = initState[key]
    })
  },
  [mutationTypes.METADATA_PENDING]: (state) => {
    state.fetching = true
  },
  [mutationTypes.METADATA_FAILURE]: (state) => {
    state.fetching = false
  },
  [mutationTypes.METADATA_SUCCESS]: (state) => {
    state.fetching = false
  },
  [mutationTypes.SET_METADATA]: (state, metadata) => {
    state.sso.enabled = metadata.sso.enabled,
    state.sso.url = metadata.sso.url
  }
}
